'use es6';

import * as ActionTypes from './ActionTypes';
import * as ecosystemClient from '../clients/ecosystemClient';
export const submitReview = review => dispatch => {
  dispatch({
    type: ActionTypes.REVIEW_WRITE_REQUESTED
  });
  return ecosystemClient.writeReview(review).then(resp => {
    dispatch({
      type: ActionTypes.REVIEW_WRITE_RECEIVED,
      payload: resp
    });
    return resp;
  });
};
export const resetReviewSubmitted = () => ({
  type: ActionTypes.REVIEW_SUBMITTED_RESET
});
export const initializeReviewFilters = entityId => ({
  type: ActionTypes.REVIEW_FILTERS_INITIALIZED,
  payload: {
    entityId
  }
});
export const updateReviewFilters = (updates, reviewTypes = ['THEME']) => ({
  type: ActionTypes.REVIEW_FILTERS_UPDATED,
  payload: {
    updates,
    reviewTypes
  }
});
export const fetchReviews = (queries, reviewTypes = ['THEME']) => dispatch => {
  dispatch({
    type: ActionTypes.REVIEWS_LIST_REQUESTED
  });
  return ecosystemClient.fetchReviews(queries, reviewTypes).then(resp => {
    dispatch({
      type: ActionTypes.REVIEWS_LIST_RECEIVED,
      payload: Object.assign({}, resp, {
        reviewTypes
      })
    });
  }).catch(error => {
    dispatch({
      type: ActionTypes.REVIEWS_LIST_FAILED,
      payload: error
    });
  });
};
export const resetReviewsListStatus = () => ({
  type: ActionTypes.REVIEWS_LIST_RESET
});
export const fetchReviewStats = (entityId, reviewType = 'THEME') => dispatch => {
  dispatch({
    type: ActionTypes.REVIEW_STATS_REQUESTED
  });
  return ecosystemClient.fetchReviewStats(entityId, reviewType).then(resp => {
    dispatch({
      type: ActionTypes.REVIEW_STATS_RECEIVED,
      payload: resp
    });
  }).catch(error => {
    dispatch({
      type: ActionTypes.REVIEW_STATS_FAILED,
      payload: error
    });
  });
};
export const resetReviewStatsStatus = () => ({
  type: ActionTypes.REVIEW_STATS_RESET
});
export const toggleReviewHelpful = (reviewId, userId, isHelpful) => dispatch => {
  dispatch({
    type: ActionTypes.REVIEW_HELPFUL_REQUESTED
  });
  return ecosystemClient.toggleHelpful(reviewId, isHelpful).then(() => {
    dispatch({
      type: ActionTypes.REVIEW_HELPFUL_RECEIVED,
      payload: {
        reviewId,
        userId,
        isHelpful
      }
    });
  });
};